import { AbstractModel } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { RideMetadataField } from './ride-metadata-field';

@inheritSerialization(AbstractModel)
export class RideMetadataValue extends AbstractModel {
  @autoserializeAs(RideMetadataField)
  rideMetadataField: RideMetadataField;

  @autoserialize
  rideRequestId: number;

  @autoserialize
  value: string;

  constructor(v: string, field: RideMetadataField) {
    super();
    this.value = v;
    this.rideMetadataField = field;
  }
}
